<template>
  <div class="form">
    <div class="form__content">
      <IdentityQueueStepCounter />
      <h1 class="extra-large-headline">
        {{ $t("PageTitle.headline.documentNumberForm") }}
      </h1>
      <p class="bodycopy">
        {{ $t("PageSubTitle.paragraph.documentNumberInstructions") }}
      </p>
    </div>
    <form @submit.prevent>
      <FormSelect
        name="documentType"
        type="text"
        iconType="DocumentCircle"
        iconColor="#0072CA"
        :defaultItem="documentType"
        :items="documentTypeList"
        :label="$t('FormSelect.label.documentType')"
        @dropdownValueUpdate="updateDropdown"
      />

      <FormInputField
        name="documentNumber"
        type="text"
        :inputValue="form.documentNumber"
        :label="$t('FormInputField.label.documentNumber')"
        :placeholder="$t('FormInputField.placeholder.documentNumber')"
        :errors="store.getErrorByField('documentNumber')"
        v-model:documentNumber="form.documentNumber"
      />

      <ButtonBase
        :isDisabled="globalStore.getIsFormLoading || store.formHasErrors"
        :isLoading="globalStore.getIsFormLoading"
        @onButtonClick="handleFormSubmit"
      >
        {{ $t("ButtonBase.label.continue") }}
      </ButtonBase>
      <IdentityQueueNext />
    </form>
  </div>
</template>

<script setup>
import { ref, watch, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";

import { useGlobalStore } from "@/stores/globalStore";
import { useDocumentNumberStore } from "@/stores/forms/documentNumbeFormStore";
import { useIdentityQueueStore } from "@/stores/identityQueueStore";

import useApiHelpers from "@/composables/api/helpers";
import useCustomerActions from "@/composables/api/useCustomerActions";
import useWatchAndUpdate from "@/composables/helpers/useWatchAndUpdate";

import ButtonBase from "@/components/ui/buttons/ButtonBase.vue";
import FormInputField from "@/components/ui/inputs/FormInputField.vue";
import FormSelect from "@/components/ui/selects/FormSelect.vue";
import IdentityQueueStepCounter from "@/components/layout/progress/IdentityQueueStepCounter.vue";
import IdentityQueueNext from "@/components/layout/progress/IdentityQueueNext.vue";

const route = useRoute();
const router = useRouter();
const globalStore = useGlobalStore();
const store = useDocumentNumberStore();
const identityQueueStore = useIdentityQueueStore();

const { postRequest } = useApiHelpers();
const { fetchCustomerId } = useCustomerActions();
const { watchAndUpdateStore } = useWatchAndUpdate();

const documentTypeList = [
  "Driver's License",
  "Passport",
  "National Identification Document",
];
const documentSubTypeMap = new Map([
  ["Driver's License", "DRIVING_LICENSE"],
  ["Passport", "PASSPORT"],
  ["National Identification Document", "IDENTIFICATION"],
]);

const form = ref({
  documentType: "",
  documentNumber: store.form.documentNumber.value || "",
});

const updateDropdown = (dropdownData) => {
  const field = Object.keys(dropdownData)[0];
  const value = Object.values(dropdownData)[0];
  form.value[field] = value;
  store.updateValue("documentType", value);
};

const handleFormSubmit = async () => {
  const formData = {
    documentType: documentSubTypeMap.get(form.value.documentType),
    documentNumber: form.value.documentNumber,
  };

  globalStore.setIsFormLoading(true);
  postRequest("documentnumber", formData, () => {
    identityQueueStore.updateToNextRoute();
    identityQueueStore.fetchNextIdentityRoute(route).then((nextRoute) => {
      router.push(nextRoute);
    });
  });
};

watchAndUpdateStore(form, store);
</script>
<style lang="scss" scoped>
.form {
  .bodycopy {
    margin-bottom: 1rem;
    @include breakpoint($min-m) {
      margin-bottom: 1.5rem;
    }
  }
}
</style>
